module.exports = __webpack_public_path__ + "img/shot_bigtx112001.ba8cc07c.png";